/**
 * Promoted (special-case) video pages.
 *
 * When a video page is opened with one of these ids, we replace the default
 * top ad in the "More News" rail with a custom creative (image link + DCM
 * impression pixel) instead of the regular Google ad slot.
 */

export interface PromotedVideoConfig {
  /** Image shown as the top item of the More News rail. */
  imageUrl: string;
  /** Page the user is sent to on click. */
  clickUrl: string;
  /** DCM impression tracker URL. `[timestamp]` will be replaced at render time. */
  impressionUrl: string;
  /** Alt text for the creative. */
  alt?: string;
  /**
   * Optional third-party verification script (e.g. IAS skeleton.js) to be
   * loaded silently alongside the impression. Fired once per page view.
   */
  verificationScriptUrl?: string;
  /**
   * Optional noscript fallback image for the verification pixel. Rendered
   * inside a <noscript> tag so crawlers / no-JS clients still register it.
   */
  verificationNoScriptImageUrl?: string;
}

const CMO_DELHI_PROMO: PromotedVideoConfig = {
  imageUrl:
    'https://media.inshorts.com/inshorts/images/v1/variants/jpg/m/2026/05_may/08_fri/img_1778229825622_335.jpg',
  clickUrl:
    'https://chatgpt.com/?prompt=Turn+this+chapter+into+quick+revision+notes+that+I+can+finish+tonight%3F&utm_source=Public&utm_medium=india-direct&utm_creative=Student-Studies&utm_content=IPL_Surround&utm_campaign=PUA_C_BRM_STAT_PUA-STUDENT-STUDIES_CHT_SEA_TRF_BRN_BRD_ALL_APAC_IN_EN_210426&dclid=CMG-6JKhqZQDFdzLhAAdwd0jrg&gad_source=7&gad_campaignid=23824435420',
  impressionUrl:
    'https://ad.doubleclick.net/ddm/trackimp/N2652748.3953536PUBLICAPP/B35423713.446257559;dc_trk_aid=639769559;dc_trk_cid=253192920;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1?',
  alt: 'ChatGPT',
  verificationScriptUrl:
    'https://pixel.adsafeprotected.com/rjss/st/2796963/92455915/skeleton.js',
  verificationNoScriptImageUrl:
    'https://pixel.adsafeprotected.com/rfw/st/2796963/92455914/skeleton.gif?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_278}&gdpr_pd=${GDPR_PD}',
};

export const PROMOTED_VIDEOS: Record<string, PromotedVideoConfig> = {
  sp_6dfl440fc0ncs: CMO_DELHI_PROMO,
  sp_1cbp7wr0l3a0x: CMO_DELHI_PROMO,
  sp_m3a1w3cqvi7u8: CMO_DELHI_PROMO,
  sp_kuok06pwtv3xb: CMO_DELHI_PROMO,
};

export function getPromotedVideoConfig(
  videoId: string | null | undefined,
): PromotedVideoConfig | null {
  // TEMPORARILY DISABLED: promoted creatives are paused; promoted video
  // pages fall back to the default Google ad slot in `InfiniteFeed`.
  // To re-enable, delete the early `return null` below — the lookup table
  // and `PromotedNewsItem` integration are intentionally left in place.
  return null;
  // eslint-disable-next-line no-unreachable
  // if (!videoId) return null;
  // return videoId ? PROMOTED_VIDEOS[videoId] : null;
}
